// extracted by mini-css-extract-plugin
export default {"separator":"separator_separator__MhoBd"};